import React from 'react';

const ChildrenComponent = ({ children }) => {
  // match business rules
  return children({ props: {} });
};

export function withBypassComponent(Component, enabled = true) {
  if (enabled) {
    return Component;
  }
  return ChildrenComponent;
}